import axios from "@axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    itemsAvailable: [],
    idNotification: "",
    url: "",
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((country) => ({
        value: country.id,
        label: country.description,
      }));
    },
    getSelectedItemsCode(state) {
      let itemCountry=[]
      state.items.forEach(element => {
        if(element.telephone_code!=null){
          itemCountry.push({
            value: element.id,
            label: `${element.code} (+${element.telephone_code})`,
          })
        }
      });
      return itemCountry
    },
    getIdNotification(state) {
      return state.idNotification;
    },
    getUrl(state) {
      return state.url;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setIdNotification(state, value) {
      state.idNotification = value;
    },
    setUrl(state, value) {
      state.url = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/external-personnel-access-control/activities", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });
      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const { t } = useI18nUtils();
        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "pisos",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Actividades",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/external-personnel-access-control/activities", params);
      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/external-personnel-access-control/activities/${id}`, params);
      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/external-personnel-access-control/activities/${id}`);
      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};